import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import { CandidateProfileSchema } from "@applicant-reviewer/api";

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profile.data(),
    queryFn: () => apiClient.get("/candidate/profile", CandidateProfileSchema),
  });
}
